import React from 'react';

const HeaderUI = () => {
    return (
        <header id="header" className="site-header">
            <div className="wrapper">
                <div className="header-content d-flex justify-content-between">
                    <div className="header-logo">
                        <a className="logo logo-primary transform-scale-h" style={{fontFamily: 'Playfair Display'}} title="Logo" href={ process.env.PUBLIC_URL + "/" }>
                            <p style={{fontSize: '28px'}}>thePrayingPhotographer<i>.com</i></p>
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HeaderUI;
